import { makeAutoObservable, observable  } from "mobx";
import { requestService } from "../services/requestService";

class RequestStore {
  constructor() {
    makeAutoObservable(this);
  }

  selApprover = "";
  status = "Awaiting Approval Request(s)";
  approvalStatusHeader = "All Awaiting Approval Request(s)";
  showRequestDialog = false;
  showNaocProductionDetailDialog = false;
  showEbendoProductionDetailDialog = false;
  showQuaiboProductionDetailDialog = false;
  showApprovalDialog = false;
  showEbendoApprovalDialog = false;
  showQuaiboApprovalDialog = false;
  showDeclineDialog = false;
  showCancellationDialog = false;
  approverParty = "";
  producingDays = [];
  productionIds = [];
  isLoading = false;
  showCommentPane = false;
  reqObj = null;
  reqGrid = {};
  myRequests = observable.map({});
  myApprovals = observable.map({});
  allApprovals = observable.map({});
  productionYear = new Date().getFullYear();
  selReqItem = {};
  selAppItems = [];
  selAppItem = {};
  statusId = 1;
  productionGrid = {};
  isSaving = false;
  approverComment = null;

  async submitRequest(
    approverId,
    requestorId,
    comment,
    productionsIds,
    assetId
  ) {
    try {
      this.isLoading = true;
      const retVal = await requestService.submitRequest(
        approverId,
        requestorId,
        comment,
        productionsIds,
        assetId
      );
      return retVal;
    } catch (error) {
      throw error;
    } finally {
      this.isLoading = false;
    }
  }

  async loadRequest(requestorId, year, assetId, statusId) {
    try {
      this.isLoading = true;
      const retVal = await requestService.loadRequest(
        requestorId,
        year,
        assetId,
        this.statusId
      );

      this.myRequests.clear();
      retVal.forEach((r) => {
        this.myRequests.set(r.requestApprovalId, r);
      });
    } catch (error) {
      throw error;
    } finally {
      this.isLoading = false;
    }
  }
  async loadApprovals(approverId, year, assetId) {
    try {
      this.isLoading = true;
      const retVal = await requestService.loadApprovals(
        approverId,
        year,
        assetId,
        this.statusId
      );

      this.myApprovals.clear();
      retVal.forEach((a) => {
        this.myApprovals.set(a.requestApprovalId, a);
      });

      //reset the buttons
      this.selAppItem = {};
      this.selAppItems = [];
    } catch (error) {
      throw error;
    } finally {
      this.isLoading = false;
    }
  }
  async loadMyApprovals(approverId) {
    try {
      this.isLoading = true;
      const retVal = await requestService.loadMyApprovals(approverId);

      this.allApprovals.clear();
      retVal.forEach((a) => {
        this.allApprovals.set(a.requestApprovalId, a);
      });
      //reset the buttons
      this.selAppItem = {};
      this.selAppItems = [];
    } catch (error) {
      throw error;
    } finally {
      this.isLoading = false;
    }
  }
  async cancelRequest(requestId, reason) {
    try {
      this.isLoading = true;
      const retVal = await requestService.cancelRequest(requestId, reason);
      return retVal;
    } catch (error) {
      throw error;
    } finally {
      this.isLoading = false;
    }
  }
  async saveApprovedProduction(data, requests, comment, approver, assetId) {
    try {
      this.isSaving = true;

      const retVal = await requestService.saveApprovedProduction(
        data,
        requests,
        comment,
        approver,
        assetId
      );
      console.log(retVal);
      return retVal;
    } catch (error) {
      throw error;
    } finally {
      this.isSaving = false;
    }
  }

  async declineRequest(requests, reason, assetId) {
    try {
      this.isLoading = true;
      const retVal = await requestService.declineRequest(
        requests,
        reason,
        assetId
      );
      return retVal;
    } catch (error) {
      throw error;
    } finally {
      this.isLoading = false;
    }
  }

  clearProducingDays() {
    this.producingDays = [];
  }

  setProducingDays(producingDays) {
    this.producingDays = producingDays;
  }
}


const requestStore = new RequestStore();
export default requestStore;

